import type { IImageConfig } from 'components/atoms/image/entities/types';

export const imageConfig: IImageConfig = {
    sources: [
        {
            media: '',
            sizes: {
                value: 256,
                unit: 'px',
            },
        },
    ],
};
